import Xhr from '@Core/xhr'

export default ({ data, option, checkout }) => {
  return {

    namespaced: true,

    state: {
      data: data || null,
      option: option || 0,
      loading: false,
      checkout: checkout || {
        form: null,
        scripts: []
      }
    },

    mutations: {

      data (state, { paymentData }) {
        state.data = paymentData
      },

      option (state, paymentOption) {
        state.option = paymentOption
      },

      checkout (state, { checkout }) {
        state.checkout = checkout
      },

      setLoading (state, { loading }) {
        state.loading = loading
      }

    },

    actions: {

      async requestPaymentData ({ state, commit }) {
        if (!state.data) {
          commit('setLoading', { loading: true })
          let paymentData = await new Xhr().get(`payment/data`)
          commit('setLoading', { loading: false })
          commit('data', { paymentData })
        }
      },

      setPaymentOption ({ commit, dispatch }, value) {
        commit('option', value)
        // dispatch('getCheckoutForm')
      },

      async getCheckoutForm ({ commit, dispatch, state }) {
        dispatch('removeCheckoutScripts')

        let checkout = await new Xhr({
          payment: state.option
        }).post('checkout/form')

        commit('checkout', { checkout })

        checkout.scripts.forEach((src) => {
          let script = document.createElement('script')
          script.className = 'checkout-script'
          script.src = src

          document.body.appendChild(script)
        })
      },

      removeCheckoutScripts () {
        [].slice.call(document.querySelectorAll('.checkout-script')).forEach((script) => {
          script.parentNode.removeChild(script)
        })
      }

    },

    getters: {
      paymentName: (state) => state.data ? state.data.options[state.option].name : ''
    }
  }
}
